<template>
  <div class="page-single">
    <div class="container">
      <div class="row">
        <div class="col col-login mx-auto">
          <div class="text-center mb-6">
            <img src="../../assets/Goalpilot_logo_white_500.png" class="h-6" alt="">
          </div>
          <div v-if="error_message" class="alert alert-danger" role="alert">
            <strong>Error!</strong> {{error_message}}
          </div>
          <form class="card" @submit.prevent="onSubmit">
            <div class="card-body p-6">
              <div class="card-title">Please enter invitation code</div>

              <div class="form-group">
                <!-- <input v-model="userInput.code" class="form-control" placeholder="Enter code"> -->

                <!-- TODO: component DigitInput.vue -->
                <input
                  v-for="x in [0,1,2,3,4,5]"
                  v-model="code_digits[x]"
                  class="digit-input"
                  :key="'digit-'+x"
                  type="text"
                  maxLength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  ref="digit"
                  @keyup="goToNextInput"
                  @keydown="onKeyDown($event, x)"
                  @click="onFocus"
                  />
              </div>

              <div class="form-footer">
                <button type="submit" class="btn btn-primary btn-block">Confirm</button>
              </div>

              <div class="mt-2">
                Didn't receive the code?<br />
                <a href="#" @click.prevent="onSendCodeAgain">Send code again</a>
              </div>

              <button @click="onLogout" class="btn btn-danger float-right">Logout</button>

            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import resourceLoader from '@/resource-loader'

// TODO: Does not work with fast typing
// TODO: auto confirm on last digit

export default {
  data() {
    return {
      error_message: '',
      num_tries: 3,
      code_digits: [],
      userInput: {
        code: '',
      }
    };
  },
  methods: {

    goToNextInput(e) {
      /*
      let key = e.which
      if (key !== 9 && (key < 48 || key > 57)) {
        e.preventDefault();
        return false;
      }
      if (key === 9) {
        return true;
      }
      */

      let sib = e.target.nextElementSibling || this.$refs.digit[0]
      sib.select()
      sib.focus();
    },

    onKeyDown(e, pos) {
      let key = e.which;
      if (key === 9 || (key >= 48 && key <= 57)) {
        // this.code_digits[ pos ] = parseInt(String.fromCharCode(key))

        // this.goToNextInput(e);
        return true;
      }

      e.preventDefault();
      return false;
    },

    onFocus(e) {
      e.target.select();
    },

    async onSendCodeAgain() {
      let currentUser = await this.$api.auth_current_user();
      this.$api.auth_request_invitation_code({ email: currentUser.email })
    },

    async onSubmit() {
      if ( this.code_digits.length !== 6 ) {
        this.error_message = 'Missing digits in code';
        return
      }
      this.userInput.code = this.code_digits.join('')

      let currentUser = await this.$api.auth_current_user();

      try {
        await this.$api.auth_check_invitation_code({
          code: this.userInput.code,
          email: currentUser.email
        })
      } catch ( error ) {
        if ( error.message === 'not-logged-in' ) {
          this.$router.push('/login')
        }
        if ( error.message === 'wrong-account' ) {
          this.$router.push('/login')
        }
        if ( error.message === 'wrong-code' ) {
          this.num_tries -= 1;

          this.error_message = 'Wrong code. You have ' + this.num_tries + ' more retries.';

          if ( this.num_tries <= 0 ) {
            this.$api.auth_logout();
            this.$router.push('/login')
          }
        }

        return
      }

      // TODO?
      // resourceLoader.afterUserRegistration({ displayName: this.userInput.userName })
      // removeRouteGuard
      // this.$api.auth_activate_use() ?
      this.$router.push({ path: this.$route.query.redirect || '/today', query: {} })
    },
    onLogout() {
      this.$api.auth_logout()
      this.$router.push('/login')
    },
    onGotoLogin() {
      this.$router.push("/login");
    }
  }
};
</script>

<style>
input.digit-input {
  margin-right: 6px;
  text-align: center;
  line-height: 50px;
  font-size: 40px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  outline: none;
  width: 42px;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;
}

input.digit-input:focus {
  border-color: #467fcf;
  box-shadow: 0 0 5px #467fcf inset;
}

input.digit-input::selection {
  background: transparent;
}
</style>
